
export const reviews = [
    
	[
    {
        "name": "Suresh k",
        "rating": "5 stars",
        "review": "Really happy with the service from Square Computers shop. Sharath Anna knows his work very well, explains everything clearly, and fixes problems quickly. Totally worth it for any computer issues, and the pricing is very budget friendly compared to other places. Perfect place for upgrades, repairs, and general IT support for both home and office systems. ❤️ 100% recommend",
        "time": "5 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVpPDsfNBBZ87vTMhCr-2Pffb3GaG1GwwhbzwdrKDz9_XCcBt28zA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Bharathi Kanchan",
        "rating": "5 stars",
        "review": "I had a very good experience with Square Computers. Sharath was very helpful and supportive. He provided a laptop in good condition exactly when I needed it for my online exam. The service was smooth and professional. Thank you for the support.",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLAasp3iqSAhA9lnDMaJ8-cdspEeCKi66Ot-VIkUiJMepH3sg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Akash. G",
        "rating": "5 stars",
        "review": "Excellent service! The technician was friendly, skilled, and quick to repair my computer. I’m very satisfied and highly recommend this service.",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVwSJBiJ28NpJKFelpI9rqNQ8GM8VYSDCXXGOC-c5_2f1bA4F4=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sudarshana Rao G D",
        "rating": "5 stars",
        "review": "Excellent Support and Assistance in any of the issues regarding the Laptop, Personal Computers. I recently purchased laptop. Well working and Cost effective. On time and Quick response to the issues of Computers. Super👍👍🎊 …",
        "time": "10 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW71i-pTPtjkHH-qADyUmG_P84O0h5Kv93EffJsgE2XDkCfRLWz=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rajashree K",
        "rating": "5 stars",
        "review": "I had some issues with my laptop, and the technician Sharath was really helpful and polite. He downgraded the Windows version as needed, and now my laptop works smoothly. Good service and honest communication. Would definitely recommend!",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVDOF6zI1jqc_2v9v7mnrLSuPhmrtjfCkLg-siwt0cZK8Q_xBc4og=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rakesh Ys",
        "rating": "5 stars",
        "review": "One stop solution for all your computer related sales and service at reasonable price ...",
        "time": "6 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUNwQ2tqawvROjXTVWKnEB5jgfDIzDaO2BenvQothxzES3w1q8h=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "K M SAIKIRAN",
        "rating": "5 stars",
        "review": "excellent customer service, with prompt diagnosis and efficient repairs, leaving my laptop functioning perfectly again; the technicians were knowledgeable and friendly, explaining the issue clearly and offering a fair price for the service, making it a highly recommended option for anyone needing laptop repairs and buying used laptops with affordable price. Thank u so much, Square Computer 😊",
        "time": "Edited a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVDXCLD8t7_QULrabOzBJ3khmFV-E_9T3LnmKSmXU6I5jR8Dw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Preetham R",
        "rating": "5 stars",
        "review": "I had a very good experience at Square Computer. Their service was quick, helpful, and professional. Sharath was friendly and solved my issue without any hassle. Highly recommend this shop for computer repairs and accessories and also best deal for refurbished laptop's",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKrE8UgRDM8hfPTsg2r-5g5EnCw4U_HhMC1EXWHkjLdS083qg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Meghana R",
        "rating": "5 stars",
        "review": "Excellent repair work. The issue is fixed quickly and professionally. Highly recommended.",
        "time": "5 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJOfzDynSz35slWLOjRIK3Tjrq3QsRYHkzmC_OVXIm-gtnBJw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shrivathsa Kedlaya H",
        "rating": "5 stars",
        "review": "I had bought two HP laptops here. Best quality product and service from Square Computers.",
        "time": "6 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVslV_wD04plR0GR9vA5Y2V5AY2z81JqGPdXDSHydcxyNwuq-5W=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prakash Pakka",
        "rating": "5 stars",
        "review": "Best deal for laptops and gaming desktop/computer accessories...",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJnOTlVx713-l44itZTYygZfh7DntHLWVo5XSOTpGV4FtfkGQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "D H E E R A J",
        "rating": "5 stars",
        "review": "Square Computers is simply fantastic! I recently had the pleasure of purchasing a system from them, and I couldn't be happier with my decision. From start to finish, my experience with Square Computers was exceptional.\n\nFirst and foremost, their customer service is top-notch. The owner is not only friendly but incredibly knowledgeable. He took the time to understand my specific needs and helped me find the perfect system that suited my requirements. His patience in answering all my questions and explaining technical details was greatly appreciated.\n\nWhen it came to product quality, Square Computers exceeded my expectations. The system I purchased has been running flawlessly since day one. It's lightning-fast, reliable, and the build quality is outstanding. I can confidently say that Square Computers offers some of the best tech products on the market.",
        "time": "Edited 2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW1IuA_xfVathsojzXjc_oovP37g4lt1VLDeq-UAgzX71KOOWQo=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Priya Madhava Bhaktha",
        "rating": "5 stars",
        "review": "Thank you for providing us the accurate, quick and the best laptop service. You deserve 5🌟..Sharath was really helpful and polite and I would definately recommend …",
        "time": "10 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVonyFsjYTe28c5GpPO3AmpHQLuVBOYfLcCc9uo_CJHx3IBj8IOjQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Surendra Holla",
        "rating": "5 stars",
        "review": "Sharath,the technician,did an absolutely perfect job. I'm extremely satisfied with his service and would highly recommended this place for laptop service...",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJXltz-VWW8OLgLYTieALu6nNv5YsVtq1hvx-jzhzUAzTtciQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Manya Jogi",
        "rating": "5 stars",
        "review": "Very good service and the person here is very humble",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXX1pnnQzDfpQ6Z0I1mkEF_5VuPQB0qRmHFa25wwV6aAipASCjp=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vinod C",
        "rating": "5 stars",
        "review": "Best in response, service, quality of product and good attitude service provider.",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVVit9siqphTY-xRqItjBbZGXJM7b6ypxZF2vritAVsyA_XPXvjXQ=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Pramath Adimoole",
        "rating": "5 stars",
        "review": "Firstly the people who got us everything was very whole- hearted\nThe way they talk to consumer is good. Customer service is up to the class",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVfInnmb9Fy4tLOkznGhygnfyJlfoDrJed3rmo62uAbVqOyZnNR=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sameekshith Acharya",
        "rating": "5 stars",
        "review": "All time fev & best..!!📈 …",
        "time": "2 weeks ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWces6lDtMHVR5AD4JnHNXtNCXeAvqs40o1Vc68Rg9eDj6EQ20=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Abhilash Devadiga",
        "rating": "5 stars",
        "review": "I have got serviced my office laptop here and also I have purchased  one used laptop for personal use too.\nReliable, prompt, professional, high quality, reasonable, quick and technically competent. Will highly recommend this place.",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW-jsdQhdXsdzbjkFBpb_jCKagFVio3HTm3aDV9ecH-vZLtkntN=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Abdul Rehaman",
        "rating": "5 stars",
        "review": "Very good service,, highly recommended",
        "time": "2 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjV55lu8nv_xkgK0cm6mnC0Js2-4B4KS3dJCuTrPYBF61jm41NLC=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Harley Quinn",
        "rating": "5 stars",
        "review": "Very friendly and good service",
        "time": "5 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWSnpcg71H7T5tZ77V-kMtf4vfYmFcqYbmzuhEiSiicM0JF4LM=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Majeed B A",
        "rating": "5 stars",
        "review": "One of the best laptop deal..\nbest prices\nThanks Sharath..",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWVQTWKJNTsVGe-KcBGJN0QTATC6WPpi6eMDzbZeFlNIjCU5yIUVA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shiva Ulthur",
        "rating": "5 stars",
        "review": "\"Exceptional laptop service – fast, reliable, and reasonably priced, ensuring your device runs smoothly with expert care and timely solutions.\"",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXCPwfPpzk_AdGMkT4Pw8Ck5ZsGFByVSdCZ0HbcSFdcjEtFsFXL=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Chethan Poojary",
        "rating": "5 stars",
        "review": "One of the Best Laptop center in udupi.\nSquare computer will provide a good service to their customers. If you want to buy new or refurbished laptop or computer just visit square computer.",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUqPw9KetxR_B3hbtg5-6YxJrE0_iLDzbddnaMb6WkSzzhIVucB=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Javed Ali",
        "rating": "5 stars",
        "review": "Best Laptop and Pc service ,Freindly Service ,fast and best service hughly recommended just love their work",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVjQbFCh6rNC3tFlXZFjqBNTO5YvanGtoTZi6AHim4gYb_PPsN2=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sanketh S Poojary",
        "rating": "5 stars",
        "review": "Bought a laptop for personal use with affordable price. Very humble owner. Highly recommend this place to buy Refurbished laptops.",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJG5Ar_kMjqV8MXzgVu6vxATj7PVt7KJ5vUOhXzXIiY7fwy0Es=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Jaidev Kamath",
        "rating": "5 stars",
        "review": "I had laptop HP pavillion and Dell 560s desktop for repair, they did very good job of explaining the problem in front of me and repaired it within a couple of days.Thank you Square computers",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjU2y1EegjSvmVqtXsO9FSCnDDUgTyl5WMQoihtHsLdy1O4GyIE=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Supreetha Aithal",
        "rating": "5 stars",
        "review": "Great experience , worth visiting, very much responsive and nice service.",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJ1cqtyWtXwKDFmigB6SESTrxNYRX7FI3RVFxvNoD2WLW27kQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shekar Poojary",
        "rating": "5 stars",
        "review": "Provides  very good and immediate services and solutions for the issues...",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXOijp86mYJTjOZcG5o0bW-67pjIv319Dm_OGu2YZxN-PYI0uMi=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "udesh purohit",
        "rating": "5 stars",
        "review": "“I recently bought a computer, and their service was excellent. Highly satisfied with the experience!”",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXhpAGYExpsYacRi4BO3O4qU7txZhyjO1D1VKN6HaQb6ZimGuns=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Nagaraj B M",
        "rating": "5 stars",
        "review": "reaally a good service provider, and quick response from shop owner..thank you",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW9skI72Fq1LTffEq0nzr3C1fkavtAEN_J2J_fque5EhCrfJ6F2=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Bhalaram Bhalaram",
        "rating": "5 stars",
        "review": "Good service...i upgraded my laptop SSD here,quick response and amazing work by owner, thanks 👍 …",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJJ17CRQxWRREo8goYFI76G3MZFCNfzAH4o_qlaF_qKchzRcA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "sanketh Acharya",
        "rating": "5 stars",
        "review": "Good quality computer",
        "time": "4 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJaHIj4frzG5ztKg1di0jmpK_RpfE8gDs_76oDrn6Sh2hcQkw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "koushal herle",
        "rating": "5 stars",
        "review": "Bought two laptops from here, kind person and have a good customer service. Had a good experience 😃 …",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUneNpFQPE9KGPHmlu9pFSHBkZ5glMOO5oD2RKWynuFBotAZ5Y=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "madwesh bv",
        "rating": "5 stars",
        "review": "Best quality products with compitative price,\nand the good service provider.",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWB5hT3HK6cxdCce394T7VLkkxCNRtJEs0f-n6l-PIFyQouPUOKlQ=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Lohith Poojary",
        "rating": "5 stars",
        "review": "I was really searching for good computers.I went to several shops and their quality was really bad.But later I found square computers recommend by my brother.And really the quality is very good.Thankyou soo much",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVEeKB_wTN6JHHfIc5hi1MeUVU8ycH6vZMo0ZRvHrfi8YLGxLQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prajwal",
        "rating": "5 stars",
        "review": "Best Place For Laptop Queries\nBest Communication Skill\n❤️‍🩹✨ …",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjX2ZQjLjU1FYsDdNZLsTaE3w_ytDJKuf16r4u69bByGrnRv6j7W=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "prajwal naik",
        "rating": "5 stars",
        "review": "I give a 5 ⭐ Happy to buy this laptop,\nLaptop is exalent condition Thank You.",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVFacH3M-sQn2qVu4BieEoEXtSVwl49gGR8dXSC1HACrJxXf0c=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Abhay shanbhogue Shanbhogue",
        "rating": "5 stars",
        "review": "Thank you for everything ❤️❤️❤️🙏🙏🙏 …",
        "time": "2 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUD1jqsZUPPn7kS-W9LPQQ7uWlI5m5_evGUX3lLW2yWJsF7kpg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Priya Raghu",
        "rating": "5 stars",
        "review": "Genuine person,Refurbished laptops are best collection, good service also, highly recommended this place for purchase Refurbished laptop...",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjV5tiTM2z_uXndneHd6D-A6dpwYa_rLLKhzNQ4KCTUgwzxhseMk=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Giridhar Prabhu",
        "rating": "5 stars",
        "review": "Best Customer service and Best condition laptops available for good price range.",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUMLIQeOYgdlqn3OE8-CnNmRD5ulpqG0HS0Lk7gzgr6ihARkII=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Lohith G B",
        "rating": "5 stars",
        "review": "Best computer 🖥️💻 laptop sales and service center in saligrama... Customer friendly person...",
        "time": "Edited 2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWnQJAo2aAav2G9idOAMf_gcMPSHnfkdG6emNn54hlHCVpkYP7c=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Raghavendra nayak",
        "rating": "5 stars",
        "review": "Great Service with care,\nPlease visit to get Computer exercise and Laptops...",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXCN6AfogNmnQUyXkYFzBLh-eG6oC-MEXKXSJK91Aw2ttdTdwnd=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Srikanth Srikanth",
        "rating": "5 stars",
        "review": "Best Quality and best price for refurbished laptops,owner is very humble and friendly...",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXl30y-O-74mlgonp00d0sBqMcwAKq9DbUcQT1ZhnkKHwwosAc=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Roopa Nagendra Devadiga",
        "rating": "5 stars",
        "review": "Good and innovative machines which also updated ....the person was too honest and experienced one.....reasonable price",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUVOM7pof__9_cj3vI3KOZxBYwv4iVOKnkWhKdZD31Z83DKmM0q=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Anusha g",
        "rating": "5 stars",
        "review": "Good service and trusted one",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLe3Pn79lDwz3nicU3stwI3zIqx5X9qHTTiKW3-Ixj_9Ma7FA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sudeep K",
        "rating": "5 stars",
        "review": "The owner is knowledgeable and service is fast and reasonable. Good service at reasonable price.",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJHDehmUNkoX1W0JDmEvy8W5Mh9BHrmPtSaJoaBBcze6okHwp0=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Umesha Acharya G",
        "rating": "5 stars",
        "review": "Best for refurbished laptop, custom pc builds",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJu8JGi591MDWDKpnP4GmJTToX0mnsb0ThToGQ_N1ME9tIBgA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "GANGADHAR MANUR",
        "rating": "5 stars",
        "review": "Good Quality and trusted sale and worth for money",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjX_5TKMY5v0JozwMTrZLnhr1Yi9F6JOfI0tOzpa4UVVH40HrVmu=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Padiyar Nandan",
        "rating": "5 stars",
        "review": "Best service with a reasonable price, owner is such a nice man✨️",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJnVSgN0fbeMkMwHwfdTSgf4411wzY-TH2yidLO6rEOj6fr=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vikram Bhandarkar",
        "rating": "5 stars",
        "review": "Must visit for New Laptops, Laptop repairs and services. Thanks for on time Software Installation & RAM upgradation.",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWdsIciqRT0YFbVkqrrtlKenrVnBhpzArlVdt7C0LkV1R0Da4LC=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "K Lavakar Kharvi",
        "rating": "5 stars",
        "review": "Very good service",
        "time": "7 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKCyqPzVcm_OiAjF1GcI0KOSYzNPWxxEpgvzTHmSkjdQVXwlw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "surendra devadiga",
        "rating": "5 stars",
        "review": "A good option for used laptops and desktops...",
        "time": "Edited 3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUfzL3ZtIvqsmlmAMo9dIVD1F5RHIMxIv7HVtx81ecIaJdxdqIB=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prathviraj R Basrur",
        "rating": "5 stars",
        "review": "best place for buying Refurbished computers , Laptops\nHighly Recommended 👍🏻 …",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWdcZUV9ywRhdRevrQhsDTen7EmzHQzJ4E_5cU86bVzBds02qBn-Q=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Sangeetha Poojari",
        "rating": "5 stars",
        "review": "Trustworthy, very good service at reasonable price",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWaUZoQss7OIvD0zz06xTaje7h7Fr3D6EzlLUzulR6JJ2BXnZLw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Avinash Shetty",
        "rating": "5 stars",
        "review": "Very good service... Customer friendly and trustworthy...",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWjwSImZZtNaqqGfCT1OIa78wA0y_d4hBPOebdya7MjYhCbPu4I=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "NIKHIL KOTIYAN",
        "rating": "5 stars",
        "review": "Laptop valuable price..... Good service 👍 …",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWOZ5ylgEePY1x4q65YrHaHqWGfx-k7IcC8c_lYnSNtwfbS7Dyl=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "kailash",
        "rating": "5 stars",
        "review": "U get best laptops and pcs here",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIj_I8fN6ZfDYyCEHWcwqOVEsSS1OoyWMrkvudjszdBlZy2BMI=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prathvi Raji",
        "rating": "5 stars",
        "review": "Best pc builders",
        "time": "9 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIORfmnSEsmEBVi4NwvpJSdLydy8g6IlHXxtOKECN2yo1TGRA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Maithra Asangi",
        "rating": "5 stars",
        "review": "Excellent service",
        "time": "7 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocI_6SPzFLj16PovrWoU4jG1BXsZvQpqW3uShbKpyUckq40YJg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rakshith R P",
        "rating": "5 stars",
        "review": "Super service.👌👌 …",
        "time": "4 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIL1_gL_PFMmDTPo3Yc-H0aPknvPZRjSs7b7NuqIE1LUdGpJQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rajendra Acharya",
        "rating": "5 stars",
        "review": "Best service.. And good response for any queries...",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXxZbwFTG_nqPYrFCO_-re4zjOXsyhauCEaUwFLibFughHp_l47EA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vinayak a",
        "rating": "5 stars",
        "review": "Best service with a reasonable price.... 👌🏻 …",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVA2G2BMs0uX0Um1GXsLz9FCxLzYW9E6pGzY6Yt9gdLXvPCbO0=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "shilpa renuka",
        "rating": "5 stars",
        "review": "Top computer shop in Udupi",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKLNd31n_57ycaQLMbwE1g9qw2m1p6sTf1wxLuDD-3lLx_kIg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vignesh Achar",
        "rating": "5 stars",
        "review": "Great service",
        "time": "Edited 2 weeks ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWAfShMab1VQvFyPblbtLbKX765qRVgM8V5oBwA3hHC0lf0fCDi=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Amith Thekkatte",
        "rating": "5 stars",
        "review": "Best service. We r happy",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVwgmohWKSad6-CS9nYMLQw-VufQwnu-QzrDfUDBnnMvzAZrnXu_Q=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Harsha Shetty",
        "rating": "5 stars",
        "review": "Super service friendly man",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVKmpZ89zpRURcg76QOwtgprn5ibMXtJALwNGX_mqKsZ1Wpjsoq=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Abhijith",
        "rating": "5 stars",
        "review": "Genuine products and fast service.",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWDP8DHZGgoJ3--Pbl8nvpHTQWlkxzluIyjRBqdPSn-Juo9X3tx=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "raghavendra kome",
        "rating": "5 stars",
        "review": "Very good service and quick response.",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW7KIVd-u3xyOCiQt6Lt4tmlR8JfJNGYH6q4pDOBjMxmzLQlLhaWA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Manaswi high",
        "rating": "5 stars",
        "review": "Very good service and reasonable pricing",
        "time": "Edited 3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKZwUr0q7yWCQBuLZlPXLWVjTqtaqPtsHKOR2T1Pn5FDIulTq8=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "melwin dsilva",
        "rating": "5 stars",
        "review": "Trusted sale and service offered by Square Computers",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLOdyC41NHtZp_eZ_sF2ggx9Zsuu9rU-tnFrlRzhR38196nLA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shraddha JR",
        "rating": "5 stars",
        "review": "Really good, customer friendly",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWOocICl62HaX1eLCilhRot02kYAS1CA7qhrssaFy8d-BR_xjA=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prasad Karanth",
        "rating": "5 stars",
        "review": "Authorized Refub Laptop and Desktop seller....",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocI_B7-gF72Ss69lMTlqyU8ryVCk0x2UIa9ImqNJ6V7hLuh9vg=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "DINESH ACHAR",
        "rating": "5 stars",
        "review": "Happy with quick and effective services",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXIdNYDNt0zxwLOVxkmKoEhAUKIJP2fJqiY6pGg0f3VLYnzNzf5uQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sunil Kumar",
        "rating": "5 stars",
        "review": "Good service and reasonable price",
        "time": "Edited a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJbAhDGzFEok2u03MTtNCzuJtPJHsBTy3bKrSNpD5gjOjcRow=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Harish Hosavoklumane vaddarse",
        "rating": "5 stars",
        "review": "Excellent fast service",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXAePwoB3tGYhrznheadtSiVmGjvggbnlFSUb9Q8lJAujU-4ZE=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Nikhil Billava",
        "rating": "5 stars",
        "review": "Excellent and quick service..🥰 …",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjV-1J_UJAecYhukubyJycPyCKKXV3O6h_PrFXFjXkyNVIYILr4=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Gourav Poojari",
        "rating": "5 stars",
        "review": "Good response",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUEISPW0YQ_E545BfVb3lzOtxgbF8WQsmN1b-sCrc_UooOjfC93Tg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "ananthakrishna holla",
        "rating": "5 stars",
        "review": "Super. Good service",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUrkSmZUrK8sJNtAfUqooN7K1XUmLRl6EtPbXtmKzZOHPWzqt9v=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sanjan Acharya",
        "rating": "5 stars",
        "review": "Good service 👍 …",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLfVoB1U1WRPiL_4wIqsQSFQJkajSYa7Pv9IUaOZbxyJCj32Yw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Dhanushree Dhanushree",
        "rating": "5 stars",
        "review": "Good",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJuJDj-HEGLtu_Zf7QQwgT5T4GriVvOfphjVKTbtyWQxuhung=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "lohith Kunder21",
        "rating": "5 stars",
        "review": "Very good services",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIyJTIxYhpJRMH2oHDoIHIu0lYW5jJWwysYc4ZX4RzEzaxzkg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rajappa S",
        "rating": "5 stars",
        "review": "Excellent 👍👍 …",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWhf801zPK_xTnZ7kkJzO5IAzPyU3s7uvCZnNgYE5Sso2ZIBiWD=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "arun adiga",
        "rating": "5 stars",
        "review": "Good survice",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXwo1hIK60c-1EvnrF53R9WMDOl2z-poPSeLTBpUh0ohaXnwoTIPQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "E TRAVELS",
        "rating": "5 stars",
        "review": "Excellent service",
        "time": "Edited a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUb9QTlg_dDvorgsoQ39hM4a8sEIHvLvy0786msdv2-h_evVdU=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "RAJATH SALIGRAMA",
        "rating": "5 stars",
        "review": "Good service",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXZjXR--rxQCMAJXoai-pT65okeP1UHonFk_BACHchuqh2Cdupa2Q=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Krishnaprasad Golekar",
        "rating": "5 stars",
        "review": "Very good service",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKg-moZrce2a56vAebq912kwN2HkmPYil3E0rpecXMSIaEdLg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Dr. K.Jagadisha Holla",
        "rating": "5 stars",
        "review": "Excellent",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWOaRq095A-FH_EQj1Q_Icvw3gA1RnWvXaWq3i2afzM11lg67Tv=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "vidya kanchan",
        "rating": "5 stars",
        "review": "Good service",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVjA83mHmHE7wHldAA02NqhGSk7fLg1x5zMCjE4QCdBYnsLeEnS=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vageesh Holla VK",
        "rating": "5 stars",
        "review": "Good service",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWmUdkDDAnuw0bYSAbGDriXM1o7MACtx5tETeNX4Le9fTb_hYGh=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Kruthika Kamath",
        "rating": "5 stars",
        "review": "Very politeful behaviour and good service",
        "time": "2 days ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKK4H-bsVD3yqvtnBZV1Ds9vHD-POnG1oBGRTyEpEuJENyOrvw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "cmkiran acharya",
        "rating": "5 stars",
        "review": "The best service",
        "time": "2 weeks ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWCwcsa4TfSS97yusnA8MHLE2-Q4zYrhqsqqfGDFoLW10UHaHwX=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "mahesh Bhandary",
        "rating": "5 stars",
        "review": "Excellent service",
        "time": "2 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKkDYZMa9jZkTAz_oWM7C_Tsv2GcyyzwmzUQuEqoknL_6Yn1g=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Gopala Kundar",
        "rating": "5 stars",
        "review": "The service was excellent. The technicians were courteous, efficient, and very knowledgeable. My computer is now fully functional. I recommend this service.",
        "time": "Edited 8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWnS4KOZFM7j8aJ-xyS_lliEqUJso6N2f4nq5kNIkG3RCoaxBR3=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Art-thetics DAW",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVcOd4QTUYTYgcJ6g9LBQ9BqPwnLaI-teyQUp0Y-O9UXHYUBELp=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Raaghavendra Acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjV6SsnrQuyM6_-cCvcg5yte6ZRt0AqFm6crTbXRWmC-gwUVVQw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Mallikarjun Security solution",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXorCJTLYYMJCICXayVJpmo3pz5Q3HFKis5PCKBdmH4WiZWRqWnFw=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Trupthi R Achar",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVekXcOmf8hoF_jha_xebkbDrqNYUebSfQqFK33fP-VTuDjjUvuBg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "S Walker' WALKER",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUwL-AkB-xscdRFNtvD0qFW6CHM3ZImuyLKZANv8c3jtWZWR8-q=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "roshan shetty",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWIW0dJL3PNMLXDoW6J7xE_lZWcoLZ3IvZB_f9vM6gSwYeoJMM=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Sandesh Acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWzei-a-6lq2YNrvABl5TPw8663Zv-7i4n7gIx2CUyBBYxgzv6IwA=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "SURESH POOJARY",
        "rating": "5 stars",
        "review": "-",
        "time": "Edited 10 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVRTyG-sZ9A4WNtFyOTCmcCEturCQq2JYL_4AWyiQCKwI0G9VbE=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "srinath acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXTHDrImIhETCc-HY1tCOKYfPsZEDe90PhD4Cha_H63vdJtrrg=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "meghana Acharya",
        "rating": "4 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIrc6q6r09rEjDl7KBNh1o0Dh4G73ptiI5ZaWqkgd5agRHdBW8N=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Harishholla V",
        "rating": "4 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUPrxaon0EtwFGXlz18nRoc5-6-Yb2NCtdAvfumN8YmAPQtcDDs=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Anantha Padiyar",
        "rating": "5 stars",
        "review": "-",
        "time": "Edited 2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUMjr5mHhHYhb2IYbsfX4ZVSzORzbJ7RNfZyZyJQBb71KGXffaz=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "prakash shanbhag",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocK6XhCbwiO2SuGkqn9odcYU_DFxa1NxO1nSIupLixWbxaw0Tw=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Deekshith",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWHE2byV4wdtPtQHwguWyXztJZo75MF6obLmR_ZXjkTuY2Y1hZi=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "franky santhosh dmello",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUv45cSnk3oyzqTwYqj-dpawdnvMNkTDbh5AZcqf4MC5P8jg2VFqQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "prasad kumar",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJjYsHMlCsyTuleisQ6aaVNT2860ufNRcOB0z3-DuPfM7G3WQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "swasthikautomart udupi",
        "rating": "5 stars",
        "review": "-",
        "time": "2 days ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUKBvdvDsUSsOQMsyDTHKa9LIROUO5WI3cgnSCShatwDMW7pF4=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "ramesh yerekoppa",
        "rating": "5 stars",
        "review": "-",
        "time": "2 weeks ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKozhyVlUmrqfevEI1DJNovJl15VheNymg0zD4aDgsO_e4c3gmy=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sclgaming Online",
        "rating": "5 stars",
        "review": "-",
        "time": "3 weeks ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJMQ8I96AhvNLaDKXrTm3GrWceMdMUemWVXpv6YrXCnGSGnHg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Ishwar singh Rajput",
        "rating": "5 stars",
        "review": "-",
        "time": "2 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKkEJ0qR1HTywM3S_CGeGW4W7_nXXgeeV0JGEn21DYtcviTmxmx=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vikyath Bhat",
        "rating": "5 stars",
        "review": "-",
        "time": "2 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWir6tnztYmCe9JSWncY2Z-unfu-d1N_60yfE0bM0PbzW49aO4j=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Ashok Kumar",
        "rating": "5 stars",
        "review": "-",
        "time": "Edited 3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUFpyk5WNAy13jbnC3WDWuXerAbC3XQrvxr6vo4x2fSlt_QtcQK=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "manjunath ural",
        "rating": "4 stars",
        "review": "-",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUd7QyMWRVF5ymMYOTflumBd_ZBvApIDbkigBMcZt0eaDKB7i8Z=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sowmya M",
        "rating": "5 stars",
        "review": "-",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWLoMKCoCjud6LBRGsyYeGe4g-VUcIkz5kO0sW-VOc6JL7a4xHNvQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prakash Kumar",
        "rating": "5 stars",
        "review": "-",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJ8aUFUdt6A9N8Qf2_W9k4Z810gZU5iP96XOpRXr29yZ7zM5GM=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Namitha Sherigar",
        "rating": "5 stars",
        "review": "-",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUSJqlt3uUzRNpLgcNhkWmrRYRWdLllvaP2CBGAMUCbNDSin2g=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shimoga Airtel",
        "rating": "5 stars",
        "review": "-",
        "time": "3 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLUYA2j2-g-9BqvURltJs4LRNgicD9wRRV2SzGaXeJdB5V5eQ=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Supreetha Shetty",
        "rating": "5 stars",
        "review": "-",
        "time": "4 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVyE4NiBzkmlT-ehio2yIYoKAm4q6wfIkJjBUbbzM74URtT_9cB=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "ADHYA SRILATHA",
        "rating": "5 stars",
        "review": "-",
        "time": "4 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJ5It_lDjy1ox_-ETLyTJ-oEVVldC6nYnqUqc5E_iFWsN7YOg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Shashtishree Madhyastha",
        "rating": "5 stars",
        "review": "-",
        "time": "6 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLimDcknZ4kI2Y2JRo5as6RpHFkBMYm2_jVbHWb_GR4NXtGJw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rohith Rao",
        "rating": "5 stars",
        "review": "-",
        "time": "6 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJOhuc0dP12twGBgvqYuj72Iq5cRGvcDikLUWUpEocU3sZjYFY=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Suhas S K",
        "rating": "5 stars",
        "review": "-",
        "time": "7 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWtKQiRNk56tLCZ_weIQ75sksaMHRk6zPTWx5LKSsdAEOXhWKPd=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Suchithra Acharya",
        "rating": "4 stars",
        "review": "-",
        "time": "7 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJH_DuAFq2yPOP2iG2g4ywvN30HU8p0pw7XBFj7Tf2dnq6hmDM=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "suprabh billava",
        "rating": "5 stars",
        "review": "-",
        "time": "8 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWRRPJwZu0yJQJ1lrn9U6rtqrVt7jz3DFgTi3WPi4k_PG3Q50Q=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "sangeetha acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "9 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWIwmZ3WHMf-TKhq9odTZcUavA822TqTl2L4DoCCrCbJ-ti9VNg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Chandanaa K S",
        "rating": "5 stars",
        "review": "-",
        "time": "9 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVxuefMMvyQFbki1m8TpNfZI7NttkmC6NUWZ5twTrVSFgLOl-It=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Pavan Adiga",
        "rating": "5 stars",
        "review": "-",
        "time": "10 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIrHZK0yt-EMSzwVaRjUA5OQReM6FwNHdw_p80Pn0EYYH-v9A=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Srinatha Urala C.K",
        "rating": "5 stars",
        "review": "-",
        "time": "11 months ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLhXEv_Hez37rcURvo3Zg7IXaD1jvcYYbJYX_nXZrJwj1eJfQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Mohan Gowda",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLDkAMz9oQzTTJX3ks9L3VnOCO8AVWR-31kMI9GsGggk8qV8Q=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Gangadhara Manur",
        "rating": "4 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWruvRjIrVV6-KXPvp4g19EHTLbbbRECiKzjbsoVRbI06GHJ8se=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Karthik Achar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVihaH1Tccrp3olJlAuQYr8aDn6U-wHu47lWxVywZCBuEKMGKzvnQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Raghavendra Puthran",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIAwpOwPHAWJoWvC1hNzuME7L36zQM-69PM9DUfwydfObxFRg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "vignesh shenoy",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUw7K7WuvyFgh2Vp1kfBIjW3cJXazYX080E_U7rZ-CIGltt-ZoI=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Ranjith achar Ranjith",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocL60sFp0Qyj2SlPVcl2rS0pQYmoh9hQDuuXbKeltSxVZEULsg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "santhosh devadiga",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIPqG8bdl3sDTo9XhJ73NmqlwibgztzrK6oid5h1OxV_O2oPQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Manoj Kumar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWFOD_sWFDqmNm_i8izzPnrvtHUlAGslfkL5Z_KEdTQxdID9Yd6_A=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Chandra Achar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocI4RkaHoKpuTXLSjylcZK_xjHllUhGGVIMgfAf__dZf_nFZ6Q=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Abhishek Poojari",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKeaguWRgGdE1b0EiV_SbDfzHusWXSmkc_iwsfNTJ6Qq97KtQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Suresh Padiyar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKxI5V0XYo2JJzqORjYhAKi14pqmyNvQJE6pr0MEbKJ4VnILw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Ajith Shetty",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW6bXwW47BlgKRifIz0kiiTE082dcRe07mcRtY53o_8s5q0T38v=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Impana Sagar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocL4sGQaYpWtVJ_3W-l_6sLi0koUjBNKs9MlyLKRbCmU5AnFhQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Nikhilesh Devadiga",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXKgh006w2Vha-Npbx6ZGswKJ_0pml__cB4awWBkCxyQBndA1Pk=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Nagendra kv",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjX6EWUEnp74BW1aEuIrwEnHKBlIdAvIByv5NbP01_wPqC3R1vm3=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "sumankumar kumar",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWHm6R-5b7HU-4CKMKKe8W9ByNedROqykEC2XkrUZRLK8ypJWpT=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Prajwal Prajwal",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJf3FG2LM8xvSLOZHI0I4gnhoDPjuTGDy1xrCV-RLwP6DUuo8k=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sachinkumar M",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXnebVWwiO0oT7EOZswusNEuMu1IvQHToapGa21fz_ib6s5AiFv=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Mithun Kumar Mendon",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVX88FcV2T7WsfNMnkukmP5gGpX74qasag9iVf0s8lUJBCPuiQoGQ=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Rajendra Saligrama (Poojary)",
        "rating": "5 stars",
        "review": "-",
        "time": "a year ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVFZFzGzK6jQSAhDdzKV5l71_KJbAiCQXSKQwogpc9fsB-QQEiEXg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "47 RAKSHITHA",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLkvoc7fwRlnH6Gohk6Hp-Q9FlVfLsT3njF4L8_AXwbYsZL2g=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Manoj kulal",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocLxH0_q7x9wYh9l5TO7fPJgEDTIV_zX-7uvWadGrjDIqbhlqQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vinayaka Studio",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjX9Mp0IFLUvAsy5bK-YGk8rSk4q_JPOXN5usiZnnModNXc6tG4=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Santhosh P",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIgQWJ_6PtEY_X55BMFG4Fuhj2zS3Iq0OkHzkId3GaJ8Pv9mQ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Jeevan U Acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUi0SjzEJ7PaLOY-0Jforzjzpim-Dd1y__skIi0gr9dh_9QWZfD=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Arjun Kunder",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjVHfLIgt172Nbi8Vup_8q95Z-StwH9h4dM7judIQJyD5ArJES3i=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Nagaraja Reddy",
        "rating": "5 stars",
        "review": "-",
        "time": "Edited 2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocIuivwPoaWiEU47KSnUy5ycyx_9H1uK5yndmkYhZghGNEwa3g=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Vishwas Bhat",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjW-w5fJ5DczYOktbvbS93Hxk5soGDNO7215Ic-WrERmlJBfyPBypw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rashmika Acharya",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXYID2tWHBcx5Lc8TV79bv4LL3WM8HRCFUH2fwa_dn0X-cWiGwK=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Dheeraj Dheeraj",
        "rating": "5 stars",
        "review": "-",
        "time": "2 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUz0G_sK1oebaEBSskfpgq0lzuAfNN1ezJGNzoFSi7s57DV_EU9=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "B S RAGHAVENDRA ACHARYA",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjWFiZ4Add-c56S-A6PbUqZCr8EP5XRs4DXnTB1C2W9J38sA_yi0=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Praveen Bangera Kodi",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXoZjyM6VjGYeS2BTg2JV0it0L9CJtwuRgXmhmsfq4dfYxewKB05w=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Rakesh kokkarne Photography",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXRdXrGa4Fia-phE2a8pTwHuCsJX0CTci7-IrNuMzkNXiFwavkK=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rakesh.R. Puthran",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJX6OvmbHRzc9bgCkUJSrXyEFZKb1Amwtn5LWy6Z_TjCUGNqg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sriraksha",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUq-USAC2cCzMJrsvtmRxGIzk06ToWgQiOvNqhpO6VJGzyJZF0Z=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "ShriLaxmi Saligrama",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUt4oq_uVJIIdfsjwUO7TbW3nKBTqRUTX4VLE2xrKcBFOb2cT69ww=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sukèsh Pèrampallí",
        "rating": "4 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocJuZMfYLF9n_q178mgevrqmuvl0A2XA8J9BIqzBrVY8gGuhHe3W=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Pavan Kumar",
        "rating": "4 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKkMfc8wRJj8Qq6Yr4kT__9lHK5cKOqdouUOo4GN8zSTi74jg=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Ayyappa Shenoy",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXwHY58EPFEEddyWAKxJDRT39KRu89T0aKFuM2u7uY4QgWZbWIK=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Rhushi Hebbar",
        "rating": "5 stars",
        "review": "-",
        "time": "3 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUQ23z6UxitBe8Q5flsJ0lPkeb0cNV5nSynaK5GcgS2GyaTLOVZ=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Kishore Kanchan",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjUAEQdfLHtJw2OyEnSgE02h1PMXeMoUysB6HONTanPVxA9A3Hqj=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Sangeetha Holla",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjU0N0WvW7LWtcwBMcNFDoTXP-7mM8SkqlDF_0z9UZN_mNYSw1xD=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Deepak Kharvi",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocK79xI3sYPXJjyzrZ0o6Y1OeQpgN-RD0NfGfpsUPFbBHfyeJw=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Nagaprasad acharya saligrama",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjU8zDeAXi2edDOp0Ij3yXJ1ZD6T2fhlYwRLNiWaFmlg14MpRfP3=w36-h36-p-rp-mo-br100"
    },
    {
        "name": "Mohith R Poojary",
        "rating": "5 stars",
        "review": "-",
        "time": "4 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a-/ALV-UjXzKEcXbxlcT2aHzqNH3dY7dLL4ppjKM3koS7BZebgoESm8AtKi=w36-h36-p-rp-mo-ba12-br100"
    },
    {
        "name": "Shreedhara Devadiga",
        "rating": "5 stars",
        "review": "-",
        "time": "5 years ago",
        "profile_picture": "https://lh3.googleusercontent.com/a/ACg8ocKUt1on1-FT4IeoA347W41w2rpPb6NCcex8SWvFFyKOyh0lLQ=w36-h36-p-rp-mo-ba12-br100"
    }
]
];
